import type { ISetUserPasswordCmd } from "@/data/commands/user/SetUserPasswordCmd";
import { Factory } from "@/data/dao/Factory";
import { UserDao } from "@/data/dao/service/UserDao";
import { Validation } from "@/data/util/Validation";

import { logError } from "@/shared/logging/errors";
import { style } from "@/shared/ui/Style";

import { i18n } from "@/portal/Trans";
import { UiNotification } from "@/portal/ui/Notification";

export class SetUserPasswordForm {
    private $form: JQuery;
    private $passwordField: JQuery;
    private $pwRepeatField: JQuery;
    private $submitBtn: JQuery;

    private identityId: string;

    constructor(element: JQuery, identityId: string) {
        this.identityId = identityId;

        this.$form = element.find(".kt-form");
        this.$form.submit((e) => {
            e.preventDefault();
            e.stopPropagation();

            this.validateAndReset();

            return false;
        });

        this.$passwordField = this.$form.find('input[name="password"]');
        this.$pwRepeatField = this.$form.find('input[name="repeatpassword"]');
        this.$submitBtn = this.$form.find('button[type="submit"]');
    }

    public validateAndReset() {
        const cmd: ISetUserPasswordCmd = {
            newPassword: this.$passwordField.val().length === 0 ? undefined : this.$passwordField.val(),
        };

        let hasError = false;
        this.$form.find(".is-invalid").removeClass("is-invalid");

        if (cmd.newPassword === undefined || !Validation.isPassword(cmd.newPassword)) {
            hasError = true;
            this.$passwordField.addClass("is-invalid");
        }

        if (cmd.newPassword !== this.$pwRepeatField.val()) {
            hasError = true;
            this.$pwRepeatField.addClass("is-invalid");
        }

        if (hasError) return;

        this.$submitBtn.addClass(style.buttonLoaderClass).prop("disabled", true).find("> .la").remove();
        Factory.getInstance<UserDao>(UserDao)
            .setPassword(this.identityId, cmd)
            .then(() => {
                UiNotification.showSuccess(i18n("user.passwordSet"));
                this.$passwordField.val("");
                this.$pwRepeatField.val("");
                this.$submitBtn
                    .removeClass(style.buttonLoaderClass)
                    .prop("disabled", false)
                    .prepend('<i class="la la-lock" />');
            })
            .catch((ex) => {
                logError(ex);
                UiNotification.showException(i18n("user.failedResetPassword"));
                this.$submitBtn
                    .removeClass(style.buttonLoaderClass)
                    .prop("disabled", false)
                    .prepend('<i class="la la-lock" />');
            });
    }
}
